
window.addEventListener("scroll", function () {
  let sticky_header = document.getElementById("header-sticky-scroll");
  let sticky_shadow = document.querySelector(".scroll-end-gradient");
  
  // Use half viewport height for consistency with footer button behavior
  const halfViewportHeight = window.innerHeight / 2;
  
  if (window.pageYOffset > halfViewportHeight) {
    // Make header sticky when scrolled past half viewport height
    sticky_header.classList.add("fixed");
    sticky_shadow.style.position = "fixed";
    sticky_header.classList.remove("relative");
    sticky_header.classList.remove("not-sticky");
    sticky_header.style.top = "0";
    sticky_header.style.width = "100%";
    sticky_header.style.zIndex = "20";
  } else {
    // Reset header position when not scrolled past half viewport height
    sticky_header.classList.remove("fixed");
    sticky_shadow.style.position = "";
    sticky_header.classList.add("relative");
    sticky_header.classList.add("not-sticky");
    sticky_header.style.zIndex = "";
  }
});

document.querySelectorAll(".section-button").forEach((button) => {
  button.addEventListener("click", () => {
    const sectionId = button.dataset.section;
    const section = document.getElementById(sectionId);
    if (section) {
      // Delay scrolling to allow time for sticky header to be applied
      setTimeout(() => {
        // Get the height of the sticky header
        const header = document.getElementById("header-sticky-scroll");
        // Calculate the position to scroll to
        const scrollToPosition =
          section.getBoundingClientRect().top + window.scrollY - 60;

        // Scroll to the section smoothly
        window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
      }, 100); // Adjust the delay as needed
    }
  });

  let buttons = document.querySelectorAll('.section-button');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove the active class from all buttons
      buttons.forEach(btn => btn.classList.remove('text-primary'));
      
      // Add the active class to the clicked button
      this.classList.add('text-primary');
    });
  });
});
